import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// ─── Sanity Client Configuration ──────────────────────────────
// Replace these with your actual Sanity project details.
// Until Sanity is set up, the app uses local sample data (see below).
const SANITY_PROJECT_ID = process.env.REACT_APP_SANITY_PROJECT_ID || '';
const SANITY_DATASET = process.env.REACT_APP_SANITY_DATASET || 'production';
const SANITY_API_VERSION = '2024-01-01';

const isSanityConfigured = Boolean(SANITY_PROJECT_ID);

export const sanityClient = isSanityConfigured
  ? createClient({
      projectId: SANITY_PROJECT_ID,
      dataset: SANITY_DATASET,
      useCdn: true,
      apiVersion: SANITY_API_VERSION,
    })
  : null;

// ─── Image URL Builder ────────────────────────────────────────
const builder = sanityClient ? imageUrlBuilder(sanityClient) : null;

export function urlFor(source) {
  if (!builder || !source) return '';
  return builder.image(source).url();
}

// ─── GROQ Queries ─────────────────────────────────────────────
export const queries = {
  allPosts: `*[_type == "blogPost"] | order(publishedAt desc) {
    _id, title, slug, publishedAt, excerpt, coverImage, tags, author
  }`,

  postBySlug: `*[_type == "blogPost" && slug.current == $slug][0] {
    _id, title, slug, publishedAt, content, coverImage, tags, author, language, featuredCards
  }`,

  postsByTag: `*[_type == "blogPost" && $tag in tags] | order(publishedAt desc) {
    _id, title, slug, publishedAt, excerpt, coverImage, tags, author
  }`,
};

// Sample posts removed - using Sanity CMS for content

// ─── Fetch Helpers ────────────────────────────────────────────
// These functions fetch from Sanity when configured, otherwise
// return empty data with a Coming Soon state.

export async function fetchAllPosts({ tag } = {}) {
  if (isSanityConfigured) {
    try {
      if (tag) {
        return await sanityClient.fetch(queries.postsByTag, { tag });
      }
      return await sanityClient.fetch(queries.allPosts);
    } catch (err) {
      console.error('Sanity fetch failed:', err);
    }
  }
  // No fallback - return empty array
  return [];
}

export async function fetchPostBySlug(slug) {
  if (isSanityConfigured) {
    try {
      return await sanityClient.fetch(queries.postBySlug, { slug });
    } catch (err) {
      console.error('Sanity fetch failed:', err);
    }
  }
  // No fallback - return null
  return null;
}

export function getAllTags() {
  // TODO: Query unique tags from Sanity when content exists
  return [];
}
